export const API_ERROR:string = 'API_ERROR';
export const API_INFO:string = 'API_INFO';
export const API_SUCCESS:string = 'API_SUCCESS';
export const API_LOADING:string = 'API_LOADING';
export const API_RESET:string = 'API_RESET';


